import {CONTRACTOR} from '../constants/actionTypes';
import initial from './initialState';

export default function (state = initial.contractorState, action) {
  switch (action.type) {
    case CONTRACTOR.GET_LIST_SUCCESS:
      return {...state, items: action.data.items || [], count: action.data.count || 0};
    case CONTRACTOR.RELOAD:
      return {...state, reload: !state.reload};
    case CONTRACTOR.GET_DETAIL_SUCCESS:
      return {...state, detail: action.data};
    case CONTRACTOR.RESET_DETAIL:
      return {...state, detail: {}};
    default:
      return state;
  }
}
